import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminRefundsService } from '../../core/services/admin-refunds.service';
import { Refund } from '../../core/models/admin.models';

@Component({
  selector: 'app-refunds-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './refunds-list.component.html'
})
export class RefundsListComponent implements OnInit {
  refunds: Refund[] = [];
  isLoading = false;
  errorMessage = '';
  updatingRefundId: number | null = null;

  constructor(private refundsService: AdminRefundsService) {}

  ngOnInit() {
    this.loadRefunds();
  }

  loadRefunds() {
    this.isLoading = true;
    this.errorMessage = '';

    this.refundsService.getRefunds().subscribe({
      next: (res) => {
        this.refunds = Array.isArray(res) ? res : (res as any).data ?? [];
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load refunds.';
        this.isLoading = false;
      }
    });
  }

  updateStatus(refund: Refund, newStatus: string) {
    this.updatingRefundId = refund.id;
    this.refundsService.updateRefundStatus(refund.id, newStatus).subscribe({
      next: () => {
        refund.status = newStatus as any;
        this.updatingRefundId = null;
      },
      error: (err) => {
        alert(err?.error?.message ?? 'Failed to update refund status.');
        this.updatingRefundId = null;
      }
    });
  }

  getBadgeColorClass(status: string): string {
    switch(status) {
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'approved': return 'bg-green-100 text-green-800';
      case 'rejected': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }
}
